import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Paper} from 'views/components';
import {InfoOutlined as InfoIcon} from 'views/icons';
import {MarkdownViewer, Translate, translate} from 'views/module';

const GeneralInformation = (props) => {
  const {generalInformation} = props;

  const clientName = generalInformation?.clientName || '';
  const address = generalInformation?.address || '';
  const clientInfo = generalInformation?.clientInfo?.blob || '';
  const notes = generalInformation?.notes?.blob || '';

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <InfoIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="loomLead.LoomLeadDetail.Careplan.GeneralInformation.Title" />
          </Typography>
        </Box>
      </Box>
      <Box sx={{p: 2}}>
        <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.GeneralInformation.ClientName"/>:
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          {clientName || translate('loomLead.LoomLeadDetail.Careplan.GeneralInformation.NoClientname')}
        </Typography>
        <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.GeneralInformation.Address"/>:
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          {address || translate('loomLead.LoomLeadDetail.Careplan.GeneralInformation.NoAddress')}
        </Typography>
        <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.GeneralInformation.Information"/>
        </Typography>
        <MarkdownViewer
          value={clientInfo || translate('loomLead.LoomLeadDetail.Careplan.GeneralInformation.NoClientInformation')}
          truncate={true}
        />
        <Typography variant="subtitle1" sx={{mt: 2, mb: 1, fontWeight: 'bold'}}>
          <Translate expression="loomLead.LoomLeadDetail.Careplan.GeneralInformation.Notes"/>
        </Typography>
        <MarkdownViewer
          value={notes || translate('loomLead.LoomLeadDetail.Careplan.GeneralInformation.NoNotes')}
          truncate={true}
        />
      </Box>
    </Paper>
  );
};

GeneralInformation.propTypes = {
  generalInformation: PropTypes.shape({
    clientName: PropTypes.string,
    address: PropTypes.string,
    clientInfo: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    notes: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
  }).isRequired,
};

export default GeneralInformation;
